import React from 'react';

function AwpToastContent({ title, msgList, isErr = true }) {
  return (
    <div style={{ maxWidth: '96%' }}>
      <div>
        {isErr && (
          <i
            className="fa fa-exclamation-circle"
            style={{ color: '#e74c3c', fontSize: '1.2rem', marginRight: '0.4rem' }}
            aria-hidden="true"
          />
        )}
        {!isErr && (
          <i
            className="fa fa-check-circle"
            style={{ color: '#07bc0c', fontSize: '1.2rem', marginRight: '0.4rem' }}
            aria-hidden="true"
          />
        )}
        {title}
      </div>
      <div
        className="overflow-auto"
        style={{ resize: 'vertical', height: '4rem', fontSize: '80%', marginTop: '0.6rem' }}
      >
        {msgList &&
          Object.values(msgList).map((msg, j) => (
            <li key={`awp_val_mod_li_${j}`} className="ml-1">
              {msg}
            </li>
          ))}
      </div>
    </div>
  );
}
export default AwpToastContent;
